<div class="page-layout simple fullwidth" perfect-scrollbar>

  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <div class="content p-24">
    <div align="center">
      <p>
        <mat-icon *ngIf="!enableCurrentYear" (click)="getCurrentYearDates()" style="cursor: pointer;">arrow_left</mat-icon>
        <b *ngIf="!enableCurrentYear" style="font-size: 20px;">Year {{nextYear}}</b>
        <b *ngIf="enableCurrentYear" style="font-size: 20px;">Year {{currentYear}}</b>
        <mat-icon *ngIf="enableCurrentYear" (click)="getNextYearDates()" style="cursor: pointer;">arrow_right</mat-icon>
      </p>
    </div>

    <div>
      <p>
        <button mat-raised-button color="accent" aria-label="Add Date" (click)="openAddDialog()">
          <mat-icon style="color : white ; margin-top : -3px">add</mat-icon>
          ADD
        </button>
        <button mat-raised-button color="accent" aria-label="Remove Date" (click)="removeDate()" [disabled]="removeBtn">
          <mat-icon style="color : white ; margin-top : -3px">remove</mat-icon>
          REMOVE
        </button>
      </p>
      <p>
        <mat-checkbox (change)="getAllCourtDates($event.checked)">Show Past Court Dates</mat-checkbox>
      </p>
    </div>

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="rows">
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
          <mat-cell *matCellDef="let element" >
            <span style="color: red;" *ngIf="element.state == 'Past'">
              {{ element.date | date: 'mediumDate'}}
            </span>
            <span style="color: blue;" *ngIf="element.state != 'Past'">
              <button mat-button color="accent" (click)="openDocket(element.date)">
                {{ element.date | date: 'mediumDate'}}
              </button>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="month">
          <mat-header-cell *matHeaderCellDef> Month </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span style="color: red;" *ngIf="element.state == 'Past'">
              {{ element.date | date: 'MMMM' }}
            </span>
            <span style="color: blue;" *ngIf="element.state != 'Past'">
              {{ element.date | date: 'MMMM' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="day">
          <mat-header-cell *matHeaderCellDef> Day </mat-header-cell>
          <mat-cell *matCellDef="let element"> 
            <span style="color: red;" *ngIf="element.state == 'Past'">
              {{ element.date | date: 'EEEE' }}
            </span>
            <span style="color: blue;" *ngIf="element.state != 'Past'">
              {{ element.date | date: 'EEEE' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="del">
          <mat-header-cell *matHeaderCellDef> Delete </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox *ngIf="element.state != 'Past'" (change)="selectedDate($event.checked, element.date)"></mat-checkbox>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSize]="30" [pageSizeOptions]="[10, 30, 50]" [showFirstLastButtons]="true">
      </mat-paginator>
    </div>


  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/court-dates/court-dates.component.html